<template>
  <div class="card" :class="isPristine()" v-if="dados.cliente">
    <div>
      <BDropdown
        dropleft
        class="button__actions"
        variant="link"
        no-caret>
        <template slot="button-content">
          <v-icon
            class="spinLoad"
            name="ellipsis-v" />
        </template>

        <BDropdownItem @click="alterarCliente(dados)">
          Identificação cliente
        </BDropdownItem>
        <BDropdownItem @click="lancarProduto(dados)">
          Lançar produtos
        </BDropdownItem>
        <BDropdownItem
          v-if="mostrarFiltroData()"
          @click="cancelarAtendimento(dados)">
          Cancelar atendimento
        </BDropdownItem>
      </BDropdown>
      <p class="card__cliente" :class="{ 'semclientevinculado': !dados.cliente.nome }">
        Cliente: {{ dados.cliente.nome || dados.cliente }}
      </p>
      <b-badge class variant="dark">
        {{ dados.funcionario.nome }}
      </b-badge>
      <p>Iniciado: {{ dados.dataAbertura | formatTime }}</p>
      <ul class="card__lista__servicos">
        <li
          v-for="item in dados.servicos"
          :key="item.codigo">
          {{ item.descricao }} - {{ item.preco | currency }}
        </li>
        <li
          v-for="item in retornaListaProdutos()"
          :key="item.produto._id">
          {{ item.produto.nome }} -
          {{ item.produto.preco | currency }}
          ({{ item.quantidade }}x)
        </li>
      </ul>
    </div>
    <div class="card__footer">
      <div class="card__totalizadores">
        <p v-if="dados.cliente && dados.cliente.bonificacao"
          class="totalizadores__bonus">
          Bonus: {{ dados.cliente.bonificacao | currency }}
        </p>
        <p>Total: <span class="totalizadores__total">
          {{ dados.total | currency }}</span>
        </p>
      </div>
      <BButton
        variant="primary"
        @click="concluir">
        Concluir
      </BButton>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BBadge,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue/es/components'

import Cargos from '@/models/Cargos'

export default {
  name: 'CardPainel',
  components: {
    BBadge,
    BButton,
    BDropdown,
    BDropdownItem,
  },
  props: {
    dados: {
      required: true,
    },
  },
  methods: {
    concluir() {
      this.$emit('concluir', this.dados)
    },
    lancarProduto() {
      this.$emit('lancarProduto', this.dados)
    },
    cancelarAtendimento(atendimento) {
      this.$emit('removerAtendimento', atendimento._id)
    },
    alterarCliente(atendimento) {
      this.$emit('alterarCliente', atendimento)
    },
    retornaListaProdutos() {
      if (this.dados.produtos) {
        return this.dados.produtos.lista
      }

      return []
    },
    isPristine() {
      return (this.dados.cliente.indicacao && !this.dados.cliente.indicacao.compareceu) ? 'borderPristine' : ''
    },
    mostrarFiltroData() {
      const cargo = this.$store.getters['autenticacao/userObj'].usuario
      if (cargo) {
        return cargo.role === Cargos.ADMINISTRADOR
      }
      return false
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";
@import "@/scss/colors.scss";

.semclientevinculado {
  color: red;
}

.borderPristine {
  border: 0.08rem solid #15ff00 !important;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0.3rem;
  border: 0.08rem solid $cor-fundo-escura;
  border-radius: 0.4rem;
  padding: 0.4rem;
  background-color: $cor-fundo-clara;

  & p {
    padding: 0;
    margin: 0;
  }

  &__lista__servicos {
    list-style: none;
    padding: 0;
    margin: 1.2rem 0;
  }

  &__cliente {
    font-weight: 500;
  }

  &__totalizadores {
    margin: 0.5em 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  &__footer {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
}

.totalizadores {
  &__bonus {
    color: $cor-azul;
    padding: 0;
    margin: 0;
  }

  &__total {
    color: $cor-verde;
    font-size: 1.4rem;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }
}

.button__actions {
  position: absolute;
  top: 16px;
  right: 4px;
}

</style>
